import { invariant } from './basler-components.es733.js';
import { noop } from './basler-components.es725.js';
import { anticipate } from './basler-components.es825.js';
import { backOut, backInOut, backIn } from './basler-components.es826.js';
import { circOut, circInOut, circIn } from './basler-components.es830.js';
import { cubicBezier } from './basler-components.es827.js';
import { easeOut, easeInOut, easeIn } from './basler-components.es754.js';
import { isBezierDefinition } from './basler-components.es775.js';

const easingLookup = {
    linear: noop,
    easeIn,
    easeInOut,
    easeOut,
    circIn,
    circInOut,
    circOut,
    backIn,
    backInOut,
    backOut,
    anticipate,
};
const isValidEasing = (easing) => {
    return typeof easing === "string";
};
const easingDefinitionToFunction = (definition) => {
    if (isBezierDefinition(definition)) {
        // If cubic bezier definition, create bezier curve
        invariant(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`, "cubic-bezier-length");
        const [x1, y1, x2, y2] = definition;
        return cubicBezier(x1, y1, x2, y2);
    }
    else if (isValidEasing(definition)) {
        // Else lookup from table
        invariant(easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`, "invalid-easing-type");
        return easingLookup[definition];
    }
    return definition;
};

export { easingDefinitionToFunction };
